module.exports = __webpack_public_path__ + "img/llegada.e54f69f7.gif";